import { UserType } from "@/types/userType";
import {
  CreateJuspayCustomerBodyType,
  CreateJuspayCustomerResponseType,
  CreateJuspayOrderResponseType,
  CreateJustpayOrderBodyType,
  GetJuspayCustomerResponseType,
  JuspayOrderResponse,
  JuspayOrderResponseType,
} from "../types/juspay.types";
import ApiService from "./ApiService";

class JuspayApi extends ApiService {
  constructor() {
    super(
      `${process.env.BACKEND_HOST_URL}/api` || "https://api.turftown.in/api"
    );
  }

  async getJustpayCustomer(customer_id: string) {
    try {
      const response = await this.post<GetJuspayCustomerResponseType>(
        "/v2/juspay/get_customer",
        { customer_id },
        true
      );
      return response;
    } catch (error) {
      throw error;
    }
  }

  async createJuspayUser(user) {
    try {
      let body: CreateJuspayCustomerBodyType = {
        email_address: user?.email,
        phone: user?.phone,
        first_name: user?.name,
        last_name: "",
        mobile_country_code: "91",
      };
      // debugger;
      const response = await this.post<GetJuspayCustomerResponseType>(
        `/v2/juspay/create_customer`,
        body,
        true
      );
      return response;
    } catch (error) {
      throw error;
    }
  }

  async getJuspayCustomer(customer_id: string) {
    try {
      const response = this.post<CreateJuspayOrderResponseType>(
        "/v2/juspay/get_customer",
        { customer_id },
        true
      );
      return response;
    } catch (error) {
      throw error;
    }
  }
  async createJuspayOrder(body): Promise<JuspayOrderResponse> {
    try {
      const response: any = await this.post(
        "/v2/juspay/create_web_session",
        body,
        true
      );
      return response?.data as JuspayOrderResponse;
    } catch (error) {
      throw error;
    }
  }
  async checkJoiningStatus(body: any) {
    try {
      const response = await this.post(
        `/v2/bookings/check_booking_status`,
        body,
        true
      );
      return response as any;
    } catch (e) {
      console.error("❌ reverseBooking error", e);
      return null;
    }
  }
}

export const juspayApi = new JuspayApi();
